import {
  Dialog,
  DialogContent,
  Card,
  CardContent,
  Typography,
  Button,
  DialogTitle,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface AnnouncementDialogProps {
  open: boolean;
  onClose: () => void;
}

const AnnouncementDialog = ({ open, onClose }: AnnouncementDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ m: 0, p: 2, textAlign: "center" }}>
        Rentrée scolaire : nouveau sur iOS
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <Card elevation={0}>
          <CardContent>
            <Typography
              variant="body1"
              gutterBottom
              sx={{ textAlign: "center" }}
            >
              Pour la rentrée scolaire, découvrez le nouvel outil Rédacteur de
              Dico API pour écrire directement des textes.
              <br />
              Il est dès maintenant disponible sur la version iOS.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <Button
                variant="contained"
                color="secondary"
                href="https://apps.apple.com/app/apple-store/id6759932379?pt=127913953&ct=Webapp%20Dialog&mt=8"
                target="_blank"
                rel="noopener"
              >
                Découvrir sur l'App Store
              </Button>
            </Box>
          </CardContent>
        </Card>
      </DialogContent>
    </Dialog>
  );
};

export default AnnouncementDialog;
